/**
 * Dependencies
 */
import { has, sum, get, round } from 'lodash'

/**
 * Return an augmented set of objects based on spread index/data
 *
 * @param  {Object} state
 * @return {Array}
 */
const calculatedSpread = (state) => {
    if (has(state.form, 'spread.data')) {
        return state.form.spread.data.map((value, idx) => {
            return {
                index: idx,
                period: state.form.spread.index[idx],
                value: value
            }
        })
    }
    return []
}

/**
 * Get the total of the spread data values
 *
 * @param  {Object} state
 * @return {Number}
 */
const totalSpreadPercentage = (state) => {
    let total = sum(get(state, 'form.spread.data', []))

    // Round with a precision of 4
    return round(total, 4)
}

/**
* Determine if a custom group is selected
*
* @param  {Object} state
* @return {Boolean}
*/
const isCustomGroupSelected = state => state.form.amount_unit === 8

export default {
    calculatedSpread,
    totalSpreadPercentage,
    isCustomGroupSelected
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/form/capex/getters.js